<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-row class="visualize">
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <div class="form-group">
          <label for="title">Title </label>
          <div class="input-group">
            <p>{{ selectionProcess.title }}</p>
          </div>
        </div>
      </b-col>
      <b-col xs="12" sm="6" md="6" lg="6" xl="6">
        <div class="form-group">
          <label for="position">Position</label>
          <div class="input-group">
            <p>{{ selectionProcess.position }}</p>
          </div>
        </div>
      </b-col>
      <b-col xs="12" sm="6" md="6" lg="6" xl="6">
        <div class="form-group">
          <label>Estimated End Date</label>
          <b-input-group class="mb-3">
            <p>{{ selectionProcess.endDate | formatDate }}</p>
          </b-input-group>
        </div>
      </b-col>
      <b-col v-if="!this.public" xs="12" sm="12" md="12" lg="12" xl="12">
        <div class="form-group">
          <label for="status">Confidential (HR personnel from other AFPs can view this selection process). </label>
          <div class="input-group">
            <p>{{ selectionProcess.confidential | formatYesNo }}</p>
          </div>
        </div>
      </b-col>
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <div class="form-group">
          <label for="status">General Comments</label>
          <div class="input-group">
            <xmp>{{ selectionProcess.comments }}</xmp>
          </div>
        </div>
      </b-col>
      <b-col>
        <div v-if="selectionProcess.selectionProcessFile.length" class="card-body">
          <h5 class="card-title">Files</h5>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" xl="12">
              <div class="col-md-12">
                <b-table hover :items="selectionProcess.selectionProcessFile" :fields="fileFields">
                  <template v-slot:cell(Options)="row">
                    <b-button v-b-tooltip.hover title="Download" variant="success" size="xs"
                      @click="downloadFile(row.item.file)"><i class="fas fa-download"></i></b-button>
                  </template>
                </b-table>

              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: { loading },
  props: {
    id: {
      type: String,
      required: true,
      default: '',
    },
    public: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      zIndex: 9999,
      selectionProcess: {},
      fileFields: [
        {
          key: 'file.name',
          label: 'Name'
        },
        {
          key: 'file.description',
          label: 'Description'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ],
    }
  },
  computed: {
    ...authComputed
  },
  created() {
    this.loadSelectionProcess()
  },
  methods: {
    loadSelectionProcess() {
      this.isLoading = true
      var headers = {}
      var url = null
      if (this.public) {
        headers = { 'content-type': 'application/x-www-form-urlencoded' }
        url = appConfig.apiUrl + `public/selection-process/${this.id}`
      } else {
        headers = { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' }
        url = appConfig.apiUrl + `selection-process/${this.id}`
      }
      axios.get(url,
        { headers: headers })
        .then((response) => {
          this.selectionProcess = response.data
        })
        .catch(error => {
          if (!this.public) {
            this.loginCheck(error.response.status)
          }
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    downloadFile(item) {
      this.isLoading = true
      var headers = {}
      var url = null
      if (this.public) {
        headers = { 'content-type': 'application/x-www-form-urlencoded' }
        url = appConfig.apiUrl + `public/download/${item.id}`
      } else {
        headers = { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' }
        url = appConfig.apiUrl + `file/download/${item.id}`
      }
      axios.get(url,
        {
          headers: headers,
          responseType: 'blob'
        })
        .then((response) => {
          if (response.data) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.originalName);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          if (!this.public) {
            this.loginCheck(error.response.status)
          }
          this.$notify({ group: 'alert', type: 'warn', title: 'Request Error', text: error });
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>